/* Bloomstep (#116): gallery, colour / size / pack picker, cart, sticky bar, reveal, FAQ tabs, dialogs. No dependencies.
   tai-dung:bo-qua theme asset chạy trong trình duyệt của khách (Shopify Ajax Cart API cùng origin), không phải script Node: tools/lib/storefront.mjs không nạp được ở đây.
   Horizon scrolls .page-wrapper on desktop (window never fires scroll, #119 R5-2): everything here uses IntersectionObserver and
   scrollIntoView, never window scroll events. */
(() => {
  document.documentElement.classList.add('pp-js');
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const smooth = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const goTo = (el, block = 'start') => el && el.scrollIntoView({ behavior: smooth, block });

  /* reveal: transform only, content always visible; stagger siblings 70 ms */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => {
    es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  $$('[data-pp-reveal]').forEach((el) => {
    const sib = el.parentElement ? $$(':scope > [data-pp-reveal]', el.parentElement).indexOf(el) : 0;
    el.style.setProperty('--d', `${Math.min(sib, 6) * 70}ms`);
    if (io) io.observe(el); else el.classList.add('is-in');
  });

  /* bridges + any in-page link */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (!a || a.getAttribute('href').length < 2) return;
    const t = document.getElementById(a.getAttribute('href').slice(1));
    if (!t) return;
    e.preventDefault();
    if (a.dataset.ppTier) { const r = $(`input[name="pp-tier"][value="${a.dataset.ppTier}"]`); if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); } }
    goTo(a.hasAttribute('data-pp-to-buy') ? ($('.pp-buy') || t) : t);
  });

  /* dialogs */
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-pp-open]');
    if (o) { const d = document.getElementById(o.dataset.ppOpen); if (d && d.showModal) d.showModal(); return; }
    const c = e.target.closest('[data-pp-close]');
    if (c) c.closest('dialog')?.close();
    if (e.target.tagName === 'DIALOG') e.target.close();
  });

  /* FAQ: "All" first and selected on load */
  $$('[data-pp-faq]').forEach((faq) => {
    const tabs = $$('.pp-tab', faq);
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      tabs.forEach((t) => { t.classList.toggle('is-on', t === tab); t.setAttribute('aria-selected', t === tab); });
      $$('.pp-qa', faq).forEach((q) => { q.hidden = tab.dataset.ppTopic !== 'all' && q.dataset.topic !== tab.dataset.ppTopic; });
    }));
  });

  /* "midnight" = today's price ends at the visitor's local midnight (evergreen) */
  const nextMidnight = () => { const d = new Date(); d.setHours(24, 0, 0, 0); return d.getTime(); };
  const endOf = (v) => (v === 'midnight' ? nextMidnight() : Date.parse(v || ''));
  const pad2 = (n) => String(n).padStart(2, '0');
  const timers = $$('[data-pp-timer]');
  if (timers.length) {
    const tickT = () => timers.forEach((el) => { const s = Math.max(0, Math.floor((endOf(el.dataset.end) - Date.now()) / 1000)); el.textContent = `${pad2(Math.floor(s / 3600))}:${pad2(Math.floor(s / 60) % 60)}:${pad2(s % 60)}`; });
    tickT(); setInterval(tickT, 1000);
  }
  /* next ship date: orders before 2 pm ship the next business day */
  $$('[data-pp-shipby]').forEach((el) => {
    const d = new Date(); d.setDate(d.getDate() + (d.getHours() >= 14 ? 2 : 1));
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    el.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  });

  /* offer bar: counts down to a real end date set in the theme editor (or "midnight"); hides itself once that date has passed */
  $$('[data-pp-promo]').forEach((bar) => {
    const end = endOf(bar.dataset.end);
    const clock = $('[data-pp-countdown]', bar);
    if (!end || !clock) { if (clock) clock.remove(); return; }
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const s = Math.floor((end - Date.now()) / 1000);
      if (s <= 0) { bar.remove(); return false; }
      const d = Math.floor(s / 86400);
      clock.textContent = `${d ? `${d}d ` : 'Ends in '}${pad(Math.floor(s / 3600) % 24)}:${pad(Math.floor(s / 60) % 60)}:${pad(s % 60)}`;
      return true;
    };
    if (tick()) setInterval(tick, 1000);
  });

  /* video loops: play only while on screen (saves data and battery), poster stays when motion is reduced */
  const vids = $$('.pp-vid video');
  // loops are GIF-like: inline on iOS, no picture-in-picture button
  vids.forEach((v) => { v.setAttribute('webkit-playsinline', ''); v.setAttribute('disablepictureinpicture', ''); });
  if (vids.length && 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const vio = new IntersectionObserver((es) => es.forEach((e) => {
      const v = e.target;
      if (e.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; v.muted = true; v.play().catch(() => {}); } else v.pause();
    }), { rootMargin: '120px 0px', threshold: 0.2 });
    vids.forEach((v) => { v.muted = true; v.setAttribute('playsinline', ''); v.addEventListener('playing', () => v.classList.add('is-on'), { once: true }); vio.observe(v); });
  }

  /* FAQ: phones start with 6 questions; "See all" or any topic tab shows the rest */
  document.addEventListener('click', (e) => { const b = e.target.closest('[data-pp-faq-all], .pp-faq [data-pp-topic]'); if (b) b.closest('.pp-faq')?.classList.add('is-all'); });

  /* folds (how-it-works): closed on phones to save scrolling, open from 990 px; the buy box "What's in every box" stays closed or it pushes the
     buy button below the first 1440×900 screen (AD-R12: button at y 1281) */
  if (matchMedia('(min-width: 990px)').matches) $$('[data-pp-fold]:not(.pp-stack)').forEach((d) => { d.open = true; });

  /* picture pins: a dot or a key writes its detail into the one line under the key (no floating box over the picture, R8 prosecutor) */
  const pinShow = (id) => {
    const tip = document.getElementById(id), grid = tip && tip.closest('.pp-inside__grid'); if (!grid) return;
    grid.querySelectorAll('.pp-pin, .pp-key').forEach((x) => x.classList.remove('is-active'));
    grid.querySelectorAll(`[aria-controls="${id}"], [data-pp-key="${id}"]`).forEach((x) => { x.classList.add('is-active'); (x.closest('.pp-pin') || x).classList.add('is-active'); });
    const out = grid.querySelector('[data-pp-detail]'); if (out) out.textContent = tip.textContent.trim();
  };
  document.addEventListener('click', (e) => {
    const k = e.target.closest('[data-pp-key]'), b = e.target.closest('[data-pp-pin]');
    if (k || b) pinShow(k ? k.dataset.ppKey : b.getAttribute('aria-controls'));
  });
  $$('.pp-keys').forEach((ol) => { const k = ol.querySelector('[data-pp-key]'); if (k) pinShow(k.dataset.ppKey); }); // each key list starts on its first item

  /* review wall: open the remaining cards in place */
  document.addEventListener('click', (e) => { const b = e.target.closest('[data-pp-more]'); if (b) b.closest('[data-pp-reviews]')?.classList.add('is-open'); });

  const main = $('[data-pp-main]');
  if (!main) return;
  let data = {};
  try { data = JSON.parse($('[data-pp-data]', main).textContent); } catch (e) { data = { variants: [] }; }
  const money = (cents) => (data.money || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
    const v = (cents / 100).toFixed(2);
    return k === 'amount_no_decimals' ? Math.round(cents / 100).toString() : v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  });

  /* gallery */
  const track = $('[data-pp-track]', main);
  const slides = track ? $$('.pp-gallery__slide', track) : [];
  const thumbs = $$('[data-pp-thumb]', main);
  const count = $('[data-pp-count]', main);
  let cur = 0;
  const setCur = (i) => {
    cur = i;
    thumbs.forEach((t, k) => t.classList.toggle('is-on', k === i));
    if (count) count.textContent = String(i + 1);
    const th = thumbs[i];
    if (th && th.parentElement) th.parentElement.scrollTo({ left: th.offsetLeft - th.parentElement.clientWidth / 2 + th.clientWidth / 2, behavior: smooth });
  };
  const show = (i) => { const s = slides[Math.max(0, Math.min(slides.length - 1, i))]; if (s && track) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: smooth }); };
  if (track && 'IntersectionObserver' in window) {
    const gio = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting && e.intersectionRatio > .6) setCur(slides.indexOf(e.target)); }), { root: track, threshold: [.6] });
    slides.forEach((s) => gio.observe(s));
  }
  thumbs.forEach((t, k) => t.addEventListener('click', () => show(k)));
  $('[data-pp-prev]', main)?.addEventListener('click', () => show(cur - 1));
  $('[data-pp-next-slide]', main)?.addEventListener('click', () => show(cur + 1));
  track?.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') show(cur + 1); if (e.key === 'ArrowLeft') show(cur - 1); });

  /* colour: the first slide shows that colour's real photo and the gallery comes into view (E3) */
  const hero = $('[data-pp-hero]', main);
  const heroOrig = hero ? { src: hero.getAttribute('src'), srcset: hero.getAttribute('srcset'), alt: hero.alt } : null;
  const colourPhotos = {};
  const tpl = $('template[data-pp-colour-photos]', main);
  if (tpl) $$('img', tpl.content).forEach((im) => { colourPhotos[im.dataset.colour] = im; });
  const colourName = $('[data-pp-colour-name]', main);
  const sizeName = $('[data-pp-size-name]', main);
  const state = { colour: $('input[name="pp-colour"]:checked', main)?.value || '', size: '', tier: 1 };
  const variantInput = $('[data-pp-variant]', main);
  const hasOpts = !!$('input[name="pp-size"]', main); // PerPulse has one variant: no colour / size to pick
  const findVariant = (c, s) => (hasOpts ? (data.variants || []).find((v) => v.c === c && v.s === s) : (data.variants || [])[0]);
  const setColour = (v, fromUser) => {
    state.colour = v;
    if (colourName) colourName.textContent = v;
    $$('[data-pp-pair-colour]', main).forEach((s) => { if (!s.dataset.touched) s.value = v; });
    const ph = colourPhotos[v];
    if (hero && fromUser) {
      if (ph) { hero.setAttribute('srcset', ph.getAttribute('srcset')); hero.setAttribute('src', ph.getAttribute('src')); hero.alt = ph.alt; }
      else if (heroOrig) { hero.setAttribute('srcset', heroOrig.srcset || ''); hero.setAttribute('src', heroOrig.src); hero.alt = heroOrig.alt; }
      show(Math.max(0, slides.indexOf(hero.closest('.pp-gallery__slide'))));
      const r = track ? track.getBoundingClientRect() : null;
      if (r && (r.top < 0 || r.top > innerHeight * .5)) goTo(track, 'start');
    }
    sync();
  };
  $$('input[name="pp-colour"]', main).forEach((r) => r.addEventListener('change', () => setColour(r.value, true)));
  $$('[data-pp-pick-colour]').forEach((b) => b.addEventListener('click', () => {
    const r = $(`input[name="pp-colour"][value="${CSS.escape(b.dataset.ppPickColour)}"]`, main);
    if (r) { r.checked = true; setColour(r.value, true); goTo(track, 'start'); }
  }));
  $$('input[name="pp-size"]', main).forEach((r) => r.addEventListener('change', () => {
    state.size = r.value; if (sizeName) sizeName.textContent = r.value;
    r.closest('.pp-opt')?.classList.remove('is-missing');
    $$('[data-pp-pair-size]', main).forEach((s) => { if (!s.dataset.touched) s.value = r.value; });
    sync();
  }));
  $$('[data-pp-pair] select', main).forEach((s) => s.addEventListener('change', () => { s.dataset.touched = '1'; }));

  /* packs */
  const pairs = $('[data-pp-pairs]', main);
  const totalEls = [...$$('[data-pp-buy-total]', main), $('[data-pp-sticky-total2]', main)];
  function sync() {
    const t = $('input[name="pp-tier"]:checked', main);
    state.tier = Number(t?.value || 1);
    if (pairs) {
      pairs.hidden = state.tier < 2;
      $$('[data-pp-pair]', main).forEach((p) => { p.hidden = Number(p.dataset.ppPair) > state.tier; });
    }
    totalEls.forEach((el) => { if (el && t) el.textContent = money(Number(t.dataset.total)); });
    const v = findVariant(state.colour, state.size);
    if (v && variantInput) variantInput.value = v.id;
  }
  $$('input[name="pp-tier"]', main).forEach((r) => r.addEventListener('change', sync));
  sync();

  /* cart: one cart/add.js with every pair, the pack code on the cart, then the theme drawer (or /cart) */
  const form = $('#pp-form');
  const msg = $('[data-pp-msg]', main);
  const say = (t) => { if (!msg) return; msg.textContent = t; msg.hidden = !t; };
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const post = (path, body) => fetch(`${root}${path}`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  let busy = false;
  form?.addEventListener('submit', async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (busy) return;
    say('');
    if (hasOpts && !state.size) { const f = $('.pp-sizes', main)?.closest('.pp-opt'); f?.classList.add('is-missing'); goTo(f, 'center'); say(data.needSize || 'Please choose your size first.'); return; }
    const first = findVariant(state.colour, state.size);
    if (!first) { say('That colour and size is not available.'); return; }
    const items = [first.id];
    if (!hasOpts) for (let i = 2; i <= state.tier; i++) items.push(first.id);
    else for (let i = 2; i <= state.tier; i++) {
      const p = $(`[data-pp-pair="${i}"]`, main);
      const c = $('[data-pp-pair-colour]', p)?.value || state.colour;
      const s = $('[data-pp-pair-size]', p)?.value;
      if (!s) { say(data.needPairSize || 'Please choose a size for each pair.'); $('[data-pp-pair-size]', p)?.focus(); return; }
      const v = findVariant(c, s);
      if (!v) { say(`Pair ${i}: that colour and size is not available.`); return; }
      items.push(v.id);
    }
    if (data.preview) { say(data.previewNote || 'Preview: the cart opens once this product is live.'); return; }
    const merged = {};
    items.forEach((id) => { merged[id] = (merged[id] || 0) + 1; });
    busy = true;
    const btn = $('[data-pp-buy]', main);
    btn?.setAttribute('aria-busy', 'true');
    try {
      const res = await post('cart/add.js', { items: Object.entries(merged).map(([id, quantity]) => ({ id: Number(id), quantity })) });
      if (!res.ok) throw new Error(`cart/add ${res.status}`);
      const code = $('input[name="pp-tier"]:checked', main)?.dataset.code;
      if (code) await post('cart/update.js', { discount: code });
      if (window.croCartDrawer && typeof window.croCartDrawer.refresh === 'function') window.croCartDrawer.refresh({ open: true });
      else window.location.href = `${root}cart`;
    } catch (err) {
      say('Sorry, something went wrong. Please try again.');
    } finally { busy = false; btn?.removeAttribute('aria-busy'); }
  }, true);

  /* sticky bar: as soon as the quick buy button under the price leaves the screen (the pack button lower down can share the screen with it); it buys when a size is chosen */
  $('[data-pp-sticky-buy]', main)?.addEventListener('click', () => {
    if (hasOpts && !state.size) { const f = $('.pp-sizes', main)?.closest('.pp-opt'); f?.classList.add('is-missing'); goTo(f, 'center'); say(data.needSize || 'Please choose your size first.'); return; }
    if (form && form.requestSubmit) form.requestSubmit(); else form?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  });
  const sticky = $('[data-pp-sticky]', main);
  const buyBtns = $$('[data-pp-quick]', main).length ? $$('[data-pp-quick]', main) : $$('[data-pp-buy]', main);
  if (sticky && buyBtns.length && 'IntersectionObserver' in window) {
    const seen = new Map();
    const sio = new IntersectionObserver((es) => {
      // a buy button still BELOW the screen counts as ahead of the reader: the bar shows only once they have scrolled past it (keeps the first screen clear)
      es.forEach((e) => seen.set(e.target, e.isIntersecting || e.boundingClientRect.top > 0));
      const on = ![...seen.values()].some(Boolean);
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      const a = $('button', sticky); if (a) a.tabIndex = on ? 0 : -1;
    });
    buyBtns.forEach((b) => sio.observe(b));
  }
})();
